<template>
  <svg
    class="w-full fill-flax-smoke-900"
    viewBox="0 0 1100 100"
    style="enable-background: new 0 0 1100 100"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g>
      <!-- S -->
      <path
        class="translate-y-full will-change-auto"
        d="M10,80 C10,80 10,95 35,95 C60,95 65,80 65,70 C65,55 50,50 35,45 C20,40 15,30 15,22 C15,10 22,5 40,5 C58,5 65,15 65,25 L55,25 C55,18 50,12 40,12 C28,12 25,18 25,22 C25,32 40,37 55,42 C70,47 75,58 75,70 C75,86 65,103 35,103 C5,103 0,85 0,80 Z"
      ></path>
      <!-- R -->
      <path
        class="translate-y-full will-change-auto"
        d="M90,6 L90,100 L100,100 L100,58 L120,58 L145,100 L157,100 L130,56 C145,52 155,42 155,30 C155,14 143,6 125,6 Z M100,14 L125,14 C137,14 145,20 145,30 C145,42 136,50 122,50 L100,50 Z"
      ></path>
      <!-- I -->
      <path
        class="translate-y-full will-change-auto"
        d="M175,6 L175,100 L185,100 L185,6 Z"
      ></path>
      <!-- K -->
      <path
        class="translate-y-full will-change-auto"
        d="M205,6 L205,100 L215,100 L215,58 L260,100 L274,100 L226,55 L272,6 L258,6 L215,52 L215,6 Z"
      ></path>
      <!-- A -->
      <path
        class="translate-y-full will-change-auto"
        d="M310,6 L280,100 L291,100 L302,68 L338,68 L349,100 L360,100 L330,6 Z M320,14 L335,60 L305,60 Z"
      ></path>
      <!-- R -->
      <path
        class="translate-y-full will-change-auto"
        d="M375,6 L375,100 L385,100 L385,58 L405,58 L430,100 L442,100 L415,56 C430,52 440,42 440,30 C440,14 428,6 410,6 Z M385,14 L410,14 C422,14 430,20 430,30 C430,42 421,50 407,50 L385,50 Z"
      ></path>
      <!-- spacer, then MADDENA -->
      <!-- M -->
      <path
        class="translate-y-full will-change-auto"
        d="M470,6 L470,100 L480,100 L480,20 L510,75 L515,75 L545,20 L545,100 L555,100 L555,6 L543,6 L512,62 L481,6 Z"
      ></path>
      <!-- A -->
      <path
        class="translate-y-full will-change-auto"
        d="M595,6 L565,100 L576,100 L587,68 L623,68 L634,100 L645,100 L615,6 Z M605,14 L620,60 L590,60 Z"
      ></path>
      <!-- D -->
      <path
        class="translate-y-full will-change-auto"
        d="M660,6 L660,100 L690,100 C715,100 730,85 730,53 C730,21 715,6 690,6 Z M670,14 L690,14 C709,14 720,26 720,53 C720,80 709,92 690,92 L670,92 Z"
      ></path>
      <!-- D -->
      <path
        class="translate-y-full will-change-auto"
        d="M745,6 L745,100 L775,100 C800,100 815,85 815,53 C815,21 800,6 775,6 Z M755,14 L775,14 C794,14 805,26 805,53 C805,80 794,92 775,92 L755,92 Z"
      ></path>
      <!-- E -->
      <path
        class="translate-y-full will-change-auto"
        d="M830,6 L830,100 L890,100 L890,92 L840,92 L840,56 L885,56 L885,48 L840,48 L840,14 L890,14 L890,6 Z"
      ></path>
      <!-- N -->
      <path
        class="translate-y-full will-change-auto"
        d="M905,6 L905,100 L915,100 L915,22 L965,100 L975,100 L975,6 L965,6 L965,84 L915,6 Z"
      ></path>
      <!-- A -->
      <path
        class="translate-y-full will-change-auto"
        d="M1015,6 L985,100 L996,100 L1007,68 L1043,68 L1054,100 L1065,100 L1035,6 Z M1025,14 L1040,60 L1010,60 Z"
      ></path>
    </g>
  </svg>
</template>
